import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './NoResults.styles';

export const NoResults = () => {
  const { t } = useTranslation('widget');

  return (
    <S.StyledNoSearchResultsWrapper>
      <S.StyledNoSearchResultsContent>
        <S.Image
          data-testid="empty-assets-img"
          src="/app/static/images/empty-state/no-search-result.svg"
          alt=""
        />
        <S.StyledNoSearchResultsText>
          {t('widget:search.noSearchResults')}
        </S.StyledNoSearchResultsText>
      </S.StyledNoSearchResultsContent>
    </S.StyledNoSearchResultsWrapper>
  );
};

